import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ConsentPres } from '../presentational/ConsentPres';
import {
  initPagesData,
  setCurrentPage,
  getConsentsByDefKey,
  toggleConsent,
  submitConsents,
  downloadConsent,
  setCurrentPageRead,
} from '../state/consentActions';
import { addToHistory } from 'src/utils/utilsActions';

class ConsentContainer extends Component {
  initPageLoaded = false;
  consentContentRef = React.createRef();
  consentInnerContentRef = React.createRef();

  componentWillUnmount() {
    sessionStorage.removeItem('consentList');
    if (this.consentContentRef.current) {
      this.consentContentRef.current.removeEventListener('DOMSubtreeModified');
    }
  }

  componentDidMount() {
    document.getElementsByClassName('nav-bar')[0].style.display = 'none';
    const { userRoles } = this.props.state.login;
    let { consentList } = this.props.state.login;
    if (!consentList) {
      consentList = JSON.parse(sessionStorage.getItem('consentList'));
    }
    //this.props.initPagesData(this.props.state.login.consentList || [1, 2, 3]);
    this.props.initPagesData(this.validateConsentListbyUserRole(consentList, userRoles.eyPro) || [1, 2, 3]);
    document.getElementsByClassName('consent-inner-content')[0].addEventListener('scroll', ev => {
      const el = ev.currentTarget;
      if (el.offsetHeight + el.scrollTop > el.scrollHeight - 20) {
        this.props.setCurrentPageRead(this.props.consent.pageIdx);
      }
    });

    if (this.consentContentRef.current && this.consentInnerContentRef.current) {
      this.consentContentRef.current.addEventListener('DOMSubtreeModified', () => {
        var el = this.consentInnerContentRef.current;
        if (el) {
          if (el.scrollHeight <= el.clientHeight) {
            this.props.setCurrentPageRead(this.props.consent.pageIdx);
          }
        }
      });
    }
  }

  validateConsentListbyUserRole(consentList, eyPro) {
    let consentListbyUserRole;
    consentListbyUserRole = consentList ? consentList : eyPro ? [1] : null;
    return consentListbyUserRole;
  }

  componentDidUpdate(props) {
    if (this.props.state.consent.pages && this.props.state.consent.pageIdx === 0 && !this.initPageLoaded) {
      this.initPageLoaded = true;
      this.loadPage(0);
    }
  }

  onNextPage = () => {
    const { pageIdx, pageCount } = this.props.consent;
    document.getElementsByClassName('consent-inner-content')[0].scrollTop = 0;
    if (pageIdx < pageCount - 1) {
      this.loadPage(pageIdx + 1);
    } else {
      this.props.setCurrentPage(pageIdx + 1);
    }
  };

  getProgress = () => {
    const { pageCount, pages } = this.props.consent;
    const acceptedPages = pages.filter(p => {
      return p.accepted;
    }).length;
    return Math.round((acceptedPages / pageCount) * 100);
  };

  onPrevPage = () => {
    const { pageIdx } = this.props.consent;
    if (pageIdx > 0) {
      this.loadPage(pageIdx - 1);
    }
  };

  loadPage = pageIdx => {
    const { pages } = this.props.consent;
    if (pages.length === 0) return;
    if (pages[pageIdx].consentData) {
      this.props.setCurrentPage(pageIdx);
    } else {
      this.props.getConsentsByDefKey(pageIdx);
    }
  };

  togleConsent = e => {
    this.props.toggleConsent(e.currentTarget.checked);
  };

  checkSubmitDisabled = () => {
    const { pageIdx, pageCount, pages } = this.props.consent;

    if (pageIdx === pageCount) {
      for (let i = 0; i < pageCount; i++) {
        if (!pages[i].accepted) {
          return true;
        }
      }
      return false;
    }
    return true;
  };

  onDownload = () => {
    let payload = { consentList: this.props.state.login.consentList || [1, 2, 3] };
    this.props.downloadConsent(payload);
  };

  submit = () => {
    this.props.submitConsents();
  };

  render() {
    const { pageIdx, pageCount, pages } = this.props.consent;

    return (
      <ConsentPres
        consentRefs={{
          consentContentRef: this.consentContentRef,
          consentInnerContentRef: this.consentInnerContentRef,
        }}
        showModal={() => {}}
        toggleModal={() => {}}
        changeMenuPage={() => {}}
        onPrevPage={this.onPrevPage}
        onNextPage={this.onNextPage}
        isNextDisabled={pageIdx >= pageCount || (pages[pageIdx] && !pages[pageIdx].accepted)}
        onCancel={() => {}}
        onSaveDraft={() => {}}
        onSubmit={this.submit}
        onDownload={this.onDownload}
        isDraftVisible={false}
        isDraftDisabled={true}
        isSubmitDisabled={this.checkSubmitDisabled()}
        isDownloadDisabled={this.checkSubmitDisabled()}
        showSummaryPage={!this.checkSubmitDisabled()}
        percentProgress={this.getProgress()}
        togleConsent={this.togleConsent}
        consentState={this.props.consent}
        {...this.props}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    consent: state.consent,
    state: state,
  };
};

const mapDispatchToProps = {
  initPagesData,
  setCurrentPage,
  getConsentsByDefKey,
  toggleConsent,
  submitConsents,
  downloadConsent,
  addToHistory,
  setCurrentPageRead,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConsentContainer);
